module.exports = __webpack_public_path__ + "img/abort.4d557e95.png";